import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
    selector: '[appMaskKitId]',
    standalone: false
})
export class MaskKitIdDirective {
  @Input() config: any;
  oldValue: string;
  constructor(private el: ElementRef, public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  onInputChange(event, backspace) {
    let newVal = event;
    const self = this;
    if (backspace || newVal && newVal.length < (self.oldValue && self.oldValue.length)) {
      self.oldValue = newVal;
      return;
    }
    const position = self.el.nativeElement.selectionStart;
    if (self.config && self.config.arrayPos) {
      if (self.config.arrayPos.indexOf(position) !== -1 && newVal.length !== self.config.arrayLength.length) {
        newVal = newVal + '-';
        self.ngControl.valueAccessor.writeValue(newVal);
        self.oldValue = newVal;
      } else {
        self.ngControl.valueAccessor.writeValue(newVal && newVal.substring(0,
          (self.config && self.config.arrayLength) ? self.config.arrayLength.length : newVal.length));
      }
    }
  }
}
